var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCassava({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC05D;}\n\t.st1{fill:#6E4926;}\n\t.st2{fill:#936031;}\n\t.st3{fill:#CC9865;}\n\t.st4{fill:none;stroke:#442414;stroke-width:2.5047;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.97,91.22c-0.03-0.19-0.1-0.39-0.19-0.58c-0.13-0.26-0.29-0.49-0.52-0.68c-0.45-0.39-1.2-0.65-2.14-0.78 c-4.08-0.58-11.71,1.07-14.17,1.46c-5.44,0.87-10.74,2.39-15.85,4.46c-5.08,2.07-9.97,4.72-14.46,7.89 c-1.36,0.97-11.19,10.58-11.87,10.58c11,3.33,22.87,0.87,33.87-2.49c3.4-1.04,6.79-2.17,10.03-3.66c2.1-1,4.14-2.14,6.02-3.49 C99.75,102.45,107.68,95.01,106.97,91.22z M76.59,111.99c0.06-0.16,0.1-0.29,0.13-0.45C76.78,111.7,76.72,111.9,76.59,111.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.17,122.32c-0.55,0.84-1.1,1.62-1.71,2.39c-4.43,5.56-10.42,9.71-16.31,13.75 c-5.21,3.62-10.61,7.28-16.82,8.7c4.72-5.05,4.24-12.84,5.44-19.64c1.33-7.64,5.21-14.82,10.9-20.09c2.1-1,4.14-2.14,6.02-3.49 c2.07-1.49,10-8.93,9.29-12.72c2.14,3.14,4.85,7.05,6.34,10.84c0.36,0.94,0.65,1.84,0.84,2.72 C115.48,110.8,113.57,117.11,110.17,122.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.37,111.99c-11.13,4.72-23.91,5.37-35.52,1.97c-2.2-0.61-4.34-1.39-6.41-2.3 c-4.79-2.14-9.45-5.08-12.13-9.61c-1.49-3.79-4.21-7.7-6.34-10.84c-0.03-0.19-0.1-0.39-0.19-0.58c1.75-1.55,3.66-2.46,5.73-2.94 c4.08-0.87,8.67-0.06,13.23,0.78c6.86,1.29,13.3,4.24,20.06,5.92c3.01,0.78,6.15,1.29,8.83,2.91c2.65,1.59,4.59,4.11,6.47,6.54 C163.2,106.56,165.3,109.28,167.37,111.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.47,135.87c-0.84,0.68-2.01,0.74-3.07,0.74c-11.58-0.06-23.52-5.69-31.22-14.3 c3.4-5.21,5.31-11.52,3.98-17.54c-0.19-0.87-0.49-1.78-0.84-2.72c2.69,4.53,7.34,7.47,12.13,9.61c2.07,0.91,4.21,1.68,6.41,2.3 c5.6,4.37,9.45,9.84,12.59,16.18C145.34,131.99,146.02,134.55,144.47,135.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.92,77.15c-1.07,3.72-1.04,7.05,0.58,10.55c-2.07,0.49-3.98,1.39-5.73,2.94 c-0.13-0.26-0.29-0.49-0.52-0.68c-0.45-0.39-1.2-0.65-2.14-0.78c0.61-2.65,1.13-5.27,1.59-7.96c0.13-0.84,0.29-1.68,0.13-2.52 c-0.13-0.87-0.55-1.65-0.97-2.39c-2.39-4.34-5.05-8.51-7.89-12.52c1.42-0.68,2.75-1.55,3.95-2.56c0.91,2.65,2.33,5.18,4.17,7.34 c0.94,1.1,2.17,2.2,3.66,2.14c0.91-0.06,1.71-0.58,2.46-1.13c2.01-1.55,3.62-3.56,4.72-5.86c0.94,1.42,1.84,2.85,2.78,4.24 C115.44,70.1,112.99,73.4,111.92,77.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.04,117.85c-3.21,1-5.64,4.09-5.86,7.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131.83,120.05c-2.11,0.9-3.36,3.16-3.77,5.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.83,100.81c0.66,1.39,1.26,2.91,1.59,4.59s0.4,3.56,0.02,5.22c0.1-0.1,0.13-0.36,0.06-0.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.97,94.52c-0.08-0.07-0.17-0.15-0.25-0.22c1.01,1.65,1.81,3.43,2.38,5.27c0.15,0.47,0.27,0.98,0.08,1.43"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 106.04,
    y1: 81.63,
    x2: 111.12,
    y2: 82.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 105.31,
    y1: 75.38,
    x2: 111.91,
    y2: 74.79
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCassava);
export default __webpack_public_path__ + "static/media/Cassava.32e1d2fe1763f09ec716c1d79a0a201e.svg";
export { ForwardRef as ReactComponent };